export default __webpack_public_path__ + "static/media/treasuredata.9a75c18c.svg";